import React, { useState } from "react";
import UploadPopup from '../JD/UploadDialog';
import { useNavigate } from 'react-router-dom';
import CandidateFollowup from "./Cc";
import RecentJobs from "./RecentJobs";
import StatCard from "./Card";
import JDModal from "../JD/JdModal";
import JdAiChoiceModal from "../JD/JdAiChoiceModal";

const Home = () => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [schedules, setSchedules] = useState([]); // State to store schedules
  const [interviewScheduledToday, setInterviewScheduledToday] = useState(0);
  const [totalInterviewScheduled, setTotalInterviewScheduled] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showJDModal, setShowJDModal] = useState(false);
  const [showJdAiChoice, setShowJdAiChoice] = useState(false);

  // ✅ Toggle dropdown visibility
  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  // ✅ Close dropdown when clicking outside
  const handleOutsideClick = (e) => {
    if (!e.target.closest('.post-job-dropdown')) {
      setShowDropdown(false);
    }
  };

  // ✅ Handle JD Actions
  const handleCreateJD = () => {
    navigate('/jd');
    setShowDropdown(false);
  };

  const handleGenerateJD = () => {
    navigate('/jdai');
    setShowDropdown(false);
  };

  const handleUploadJD = () => {
    navigate('/uploadjd');
    //setShowPopup(true);
    setShowDropdown(false);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const handleApplicantClick = (jobId) => {
    navigate(`/ranking?jobID=${encodeURIComponent(jobId)}`, { state: { jobID: jobId } });
  };

  const handleJdAiChoice = (type) => {
    setShowJdAiChoice(false);
    if (type === 'audio') {
      navigate('/jdaudio');
    } else if (type === 'text') {
      navigate('/jdai');
    }
  };

  const fetchUpcomingSchedule = async () => {
    try {
      const response = await fetch("/api/company_upcoming_schedules", {
        method: "POST",
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setTotalInterviewScheduled(data.length);

      // Get today's date for comparison
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // Filter the schedules to show only those that are today or in the future
      const upcomingSchedules = data.filter(schedule => {
        const scheduleDate = new Date(schedule.scheduled_time);
        if (scheduleDate.toDateString() === today.toDateString()) {
          setInterviewScheduledToday(interviewScheduledToday + 1);
        }
        return scheduleDate >= today;
      });

      console.log("Upcoming schedules:", upcomingSchedules);
      setSchedules(upcomingSchedules);
    } catch (error) {
      console.error("Error fetching upcoming schedule:", error);
    }
  };

  const convertToIST = (gmtDate) => {
    // Create a Date object from the GMT date string
    const date = new Date(gmtDate);

    // Format the date to a beautified string (e.g., March 13, 2025, 12:46 PM)
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true, // To show AM/PM
      timeZone: 'UTC', // Ensure it stays in GMT
    };
    return date.toLocaleString('en-IN', options);
  };

  const [jobs, setJobs] = useState([]);

  // ✅ Add event listener for outside clicks
  React.useEffect(() => {
    async function fetchJobs() {
      try {
        const response = await fetch("/api/get_jd");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setJobs(data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchJobs();
    fetchUpcomingSchedule();
    document.addEventListener('click', handleOutsideClick);
    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
    );
  }


  return (
    <>
      <div className="homev2">
        <div className="welcome-section-v2">
          {/* <h1>Hello, Welcome NewZenAlpha</h1> */}

          {/* ✅ Post Job Button with Dropdown */}
          <div className="post-job-dropdown">
            <button className="post-job-btn-v2-ch" onClick={toggleDropdown}>Post Job ▾</button>

            {showDropdown && (
              <div className="dropdown-menu">
                <button className="dropdown-item" onClick={() => setShowJdAiChoice(true)}>
                  Create JD
                </button>
                {/* <button className="dropdown-item" onClick={() => setShowJdAiChoice(true)}>
                  Generate JD with AI
                </button> */}
                <button className="dropdown-item" onClick={handleUploadJD}>
                  Upload JD
                </button>
              </div>
            )}
          </div>

          {/* ✅ Upload JD Popup */}
          {showPopup && <UploadPopup onClose={handleClosePopup} onUpload={handleUploadJD} />}
        </div>
        <div className="dashboard-container">
          <div className="cards-container">
            <StatCard title="Active Jobs" colour="#ffefe7" count="04" icon="https://cdn.builder.io/api/v1/image/assets/TEMP/1b893a3259dbf8002a9df3d65c98b2591e2771f956e6e7d35a82933adf42f3a4?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4" />
            <StatCard title="New Applications" colour="#e8f0fb" count="04" icon="https://cdn.builder.io/api/v1/image/assets/TEMP/69e937a765c8fb30968aa24f48e1ed3744a9ff20b53d0eab01cf2340dde09514?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4" />
            <StatCard title="Selected Candidate" colour="#fdebf9" count="08" icon="https://cdn.builder.io/api/v1/image/assets/TEMP/5df09de77d8009c9989329c66924319c0dfbeeddcf49a87bc021f3d4a17b9048?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4" />
            <StatCard title="No. of Interviews Done" colour="#d1f5fd" count={totalInterviewScheduled - schedules.length} icon="https://cdn.builder.io/api/v1/image/assets/TEMP/15623d03a83826a360c6393aaaa3a42f609bcc72d517b820ebea3454a9bb5c80?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4" />
            <StatCard title="Interview Scheduled Today" colour="#d9ffe2" count={interviewScheduledToday} icon="https://cdn.builder.io/api/v1/image/assets/TEMP/7430cb9d6ec5b3476b0a3d2e3835948fb77f85cb87835a6aa517e06a948e10f1?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4" />
          </div>
          <div className="ddashboard">
            <div className="dchart">
              <div className="chart-section-v2-trial">
                <div className="chart-header-v2">
                  <h2>Overview of Active Jobs</h2>
                  <div className="chart-filter-v2">
                    <span>Month</span>
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/2921160c9100cfc9e9704213dae0ba0daecd34621dab47297f1e437d36bd0640?placeholderIfAbsent=true&apiKey=1de991be0a104079ba790b2b7061fba4"
                      alt=""
                      className="filter-icon-v2"
                    />
                  </div>
                </div>
                <div className="chart-divider-v2"></div>
                <div className="chart-content-v2">
                  <div className="chart-y-axis-v2">
                    <span>80</span>
                    <span>60</span>
                    <span>40</span>
                    <span>20</span>
                    <span>00</span>
                  </div>
                  <div className="chart-bars-v2">
                    <div className="bar-group-v2">
                      <div className="bar-v2 bar-saved-v2"></div>
                      <div className="bar-v2 bar-new-v2"></div>
                      <div className="bar-v2 bar-interviewed-v2"></div>
                      <div className="bar-v2 bar-reviewed-v2"></div>
                      <div className="bar-v2 bar-shortlist-v2"></div>
                    </div>
                    <div className="chart-legend-v2">
                      <div className="legend-item-v2">
                        <div className="legend-color-v2 new-v2"></div>
                        <span>New</span>
                      </div>
                      <div className="legend-item-v2">
                        <div className="legend-color-v2 interviewed-v2"></div>
                        <span>Interviewed</span>
                      </div>
                      <div className="legend-item-v2">
                        <div className="legend-color-v2 reviewed-v2"></div>
                        <span>Reviewed</span>
                      </div>
                      <div className="legend-item-v2">
                        <div className="legend-color-v2 shortlist-v2"></div>
                        <span>Shortlist</span>
                      </div>
                      <div className="legend-item-v2">
                        <div className="legend-color-v2 saved-v2"></div>
                        <span>Saved</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="dschedule">
              <div className="schedule-section-v2-trial">
                <div className="schedule-header-v2">
                  <h2>Upcoming Candidate Interviews</h2>
                </div>
                <div className="schedule-list-v2">
                  <div>
                    {schedules.length === 0 ? (
                      <p>No upcoming schedules available.</p>
                    ) : (
                      schedules.map((schedule, index) => (
                        <div key={index} className="schedule-item-v2">
                          <div className="schedule-content-v2">
                            {/* Append test type after topic */}
                            <p><strong>
                              {schedule.topic}{" "}
                              {schedule.test_type === "t" && "(Technical Test)"}
                              {schedule.test_type === "p" && "(Personality Test)"}
                              {schedule.test_type === "b" && "(Behavioral Test)"}
                              {schedule.test_type === "c" && "(Coding Test)"}
                            </strong>
                            </p>

                            {/* Display numbered full names line by line */}
                            <p>Candidate Name(s):</p>
                            {schedule.full_names
                              ?.split(", ")
                              .map((name, i) => (
                                <p key={i}>
                                  {i + 1}. {name}
                                </p>
                              ))}

                            <span>Scheduled Time: {convertToIST(schedule.scheduled_time)}</span>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="dposts">
              <RecentJobs jobs={jobs} />
            </div>
            <div className="djobs">
              <CandidateFollowup maxHeight={400} />
            </div>
          </div>
        </div>
        <JDModal isOpen={showJDModal} onClose={() => setShowJDModal(false)} />
        <JdAiChoiceModal
          isOpen={showJdAiChoice}
          onClose={() => setShowJdAiChoice(false)}
          onSelect={handleJdAiChoice}
        />
      </div>
    </>
  );
};



export default Home;
